import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginUser } from '../api';
import './Auth.css';

function LoginPage({ onLoginSuccess }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const navigate = useNavigate();

    const handleLogin = async () => {
        setErrorMsg('');
        const res = await loginUser(username, password);

        if (res.token) {
            onLoginSuccess(res.token);
            navigate('/');
        } else {
            setErrorMsg(res.message || 'Ошибка входа');
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <h2>Вход</h2>
                <p className="auth-subtitle">
                    Войдите в систему, чтобы полноценно пользоваться магазином
                </p>

                <div className="input-group">
                    <input
                        type="text"
                        placeholder="Имя пользователя"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                    />
                </div>

                <div className="input-group">
                    <input
                        type="password"
                        placeholder="Пароль"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                </div>

                {errorMsg && <div className="error-msg">{errorMsg}</div>}

                <button className="auth-btn" onClick={handleLogin}>
                    Войти
                </button>

                <div className="switch-auth">
                    <span>Нет аккаунта?</span>{' '}
                    <Link to="/register" className="register-link">
                        Зарегистрироваться
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;